;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();export const computeCardOrders = (cards, cardDistribution, columns) => {
    if (columns === 2) {
        // Small breakpoint: both card types span 2 (full row).
        // Row 1 has 2 products (indices 0, 1); each subsequent injected card follows 2 (Dense) or 4 (Sparse) products.
        const step = cardDistribution === 'Sparse' ? 4 : 2;
        return cards.map((_, i) => 2 + step * i);
    }

    const extraRows = cardDistribution === 'Sparse' ? 1 : 0;
    let productsCount = 0;

    return cards.map((card, i) => {
        const colSpan = card.__typename === 'CardInternalLink' ? 2 : 1;
        if (i % 2 === 0) {
            // Even index: card is the last item in its row.
            productsCount += columns - colSpan;
            const order = productsCount;
            productsCount += extraRows * columns;
            return order;
        }

        // Odd index: card is the first item in its row.
        const order = productsCount;
        productsCount += columns - colSpan;
        productsCount += extraRows * columns;
        return order;
    });
};

const getOrderedItems = (cards, productCount, cardDistribution, columns) => {
    const orders = computeCardOrders(cards, cardDistribution, columns);
    const items = cards.map((card, i) => ({
        type: 'card',
        index: i,
        colSpan:
            columns === 2 ? 2 : card.__typename === 'CardInternalLink' ? 2 : 1,
        order: orders[i],
        domIndex: i,
    }));

    for (let i = 0; i < productCount; i += 1) {
        items.push({
            type: 'product',
            index: i,
            colSpan: 1,
            order: i,
            domIndex: cards.length + i,
        });
    }

    return items.sort((a, b) =>
        a.order !== b.order ? a.order - b.order : a.domIndex - b.domIndex
    );
};

export const computeFillerSpans = (
    cards = [],
    productCount = 0,
    cardDistribution = 'Sparse'
) => {
    return [2, 3, 4].reduce((spans, columns) => {
        let currentCol = 1;

        getOrderedItems(cards, productCount, cardDistribution, columns).forEach(
            item => {
                if (currentCol + item.colSpan - 1 > columns) {
                    currentCol = 1;
                }

                currentCol += item.colSpan;
                if (currentCol > columns) {
                    currentCol = 1;
                }
            }
        );

        // currentCol === 1 means the last row was fully filled (or there are no items)
        spans[columns] = currentCol === 1 ? 0 : columns - currentCol + 1;
        return spans;
    }, {});
};

export const computeItemVisibility = (
    cards = [],
    products = [],
    cardDistribution = 'Sparse'
) => {
    const ROW_LIMITS = {
        2: 8,
        3: 5,
        4: 5,
    };
    const hasMore = {
        small: false,
        large: false,
        xxLarge: false,
    };
    const cardVisibility = cards.map(() => ({
        hideSmall: false,
        hideLarge: false,
        hideXXLarge: false,
    }));
    const productVisibility = products.map(() => ({
        hideSmall: false,
        hideLarge: false,
        hideXXLarge: false,
    }));

    [2, 3, 4].forEach(columns => {
        const rowLimit = ROW_LIMITS[columns];
        const items = getOrderedItems(
            cards,
            products.length,
            cardDistribution,
            columns
        );

        let currentRow = 1;
        let currentCol = 1;

        for (const item of items) {
            if (currentCol + item.colSpan - 1 > columns) {
                currentRow += 1;
                currentCol = 1;
            }

            if (currentRow > rowLimit) {
                if (columns === 2) {
                    hasMore.small = true;
                    if (item.type === 'card') {
                        cardVisibility[item.index].hideSmall = true;
                    } else {
                        productVisibility[item.index].hideSmall = true;
                    }
                } else if (columns === 3) {
                    hasMore.large = true;
                    if (item.type === 'card') {
                        cardVisibility[item.index].hideLarge = true;
                    } else {
                        productVisibility[item.index].hideLarge = true;
                    }
                } else if (columns === 4) {
                    hasMore.xxLarge = true;
                    if (item.type === 'card') {
                        cardVisibility[item.index].hideXXLarge = true;
                    } else {
                        productVisibility[item.index].hideXXLarge = true;
                    }
                }
            }

            currentCol += item.colSpan;
            if (currentCol > columns) {
                currentRow += 1;
                currentCol = 1;
            }
        }
    });

    return {
        hasMore,
        cardVisibility,
        productVisibility,
    };
};
